import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import {
  IReferralRequestInfo,
  ISendReferralEmailRequest,
  ISendReferralTextRequest,
} from '../models/referral-request.model';

@Injectable({ providedIn: 'root' })
export class ReferralRequestService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/client-portal/referral-request`;

  getInfo(): Observable<IReferralRequestInfo> {
    return this.http.get<IReferralRequestInfo>(`${this.baseUrl}/info`);
  }

  sendEmail(request: ISendReferralEmailRequest): Observable<ISendReferralEmailRequest> {
    return this.http.post<ISendReferralEmailRequest>(`${this.baseUrl}/email`, request);
  }

  sendText(request: ISendReferralTextRequest): Observable<ISendReferralTextRequest> {
    return this.http.post<ISendReferralTextRequest>(`${this.baseUrl}/text`, request);
  }
}
